<template>
    <div class="section center sitesectionwide">
        <h3>N'attendez plus ! Opérez votre transformation Digitale dès maintenant !</h3>
        <h5>Un site internet moderne c'est avant tout :</h5><br>
        <div class="row container">
          <div class="col s12 l4 offset-l4" data-aos="zoom-in">
            <i class="material-icons white-text medium">trending_up</i><br>
            Un investissement rentable
          </div>
        </div>
        <div class="row container">
          <div class="col s12 l4" data-aos="zoom-in-right">
            <i class="material-icons white-text medium">compare</i><br>
            Une bonne façon de se démarquer de vos concurrents
          </div>
          <div class="col s12 l4" data-aos="zoom-in">
            <i class="material-icons white-text medium">event_seat</i><br>
            Une marque de crédibilité
          </div>
          <div class="col s12 l4" data-aos="zoom-in-left">
            <i class="material-icons white-text medium">store</i><br>
            La vitrine de votre entreprise
          </div>
        </div>
        <div class="row container">
          <div class="col s12 l4" data-aos="zoom-in-right">
            <i class="material-icons white-text medium">library_books</i><br>
            Une source d'information toujours disponible
          </div>
          <div class="col s12 l4" data-aos="zoom-in">
            <i class="material-icons white-text medium">search</i><br>
            Une façon de mieux connaitre ses clients
          </div>
          <div class="col s12 l4" data-aos="zoom-in-left">
            <i class="material-icons white-text medium">people</i><br>
            Un moyen d'attirer de nouveaux clients
          </div>
        </div>
        <ctabutton></ctabutton>
    </div>
</template>

<script>
import Ctabutton from './Ctabutton'

export default {
  name: 'sitesectionwide',
  components: {Ctabutton}
}
</script>

<style scope>
.sitesectionwide{
    padding-left: 24px;
    padding-right: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Sitesectionwide.vue